"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CC = _interopRequireDefault(require("./icons/CC"));

var _By = _interopRequireDefault(require("./icons/By"));

var _Nd = _interopRequireDefault(require("./icons/Nd"));

var _Nc = _interopRequireDefault(require("./icons/Nc"));

var _Sa = _interopRequireDefault(require("./icons/Sa"));

var _Pd = _interopRequireDefault(require("./icons/Pd"));

var _Pdm = _interopRequireDefault(require("./icons/Pdm"));

var _Copyright = _interopRequireDefault(require("./icons/Copyright"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    "& * + *": {
      marginLeft: theme.spacing(1)
    }
  },
  icon: {
    fontSize: "inherit",
    fill: "currentColor",
    "& *": {
      fill: "currentColor"
    }
  }
}));
const icons = {
  "cc": _CC.default,
  "by": _By.default,
  "nd": _Nd.default,
  "nc": _Nc.default,
  "sa": _Sa.default,
  "pd": _Pd.default,
  "pdm": _Pdm.default,
  "copyright": _Copyright.default
};

const LicenseIcon = ({
  className,
  license
}) => {
  const licenseIcons = license.split('-') || [license];
  const classes = useStyles();
  return _react.default.createElement("div", {
    className: className || classes.root
  }, licenseIcons.map(icon => {
    const Icon = icons && icons[icon];

    if (Icon) {
      return _react.default.createElement(Icon, {
        className: classes.icon
      });
    }

    return false;
  }));
  return _react.default.createElement("p", null, JSON.stringify(licenseIcons));
};

var _default = LicenseIcon;
exports.default = _default;
module.exports = exports.default;